import FilePage from './FilePage';

export default FilePage;
